<template>
    <div class="globInt">
        <vc-table :maxItems="30" :pagination="false" ref="tables" stripe :tableData="integrations">
            <template v-slot:head>
                <vs-th style="width: 4%">
                    <vs-checkbox v-model="active" class="w-full"></vs-checkbox>
                </vs-th>
                <vs-th>{{$t('global.Name')}}</vs-th>
                <vs-th>{{$t('global.Geo')}}</vs-th>
                <vs-th>{{$t('global.Model')}}</vs-th>
            </template>

            <template v-slot:content="{content}">
                <vs-td>
                    <vs-checkbox @input="select(content)" v-model="content.active"></vs-checkbox>
                </vs-td>

                <vs-td>
                    <div>{{content.name}}</div>
                </vs-td>

                <vs-td>
                    <div>{{content.geo.name}}</div>
                </vs-td>

                <vs-td>
                    <div>{{content.traffic_model.name}}</div>
                </vs-td>
            </template>
        </vc-table>

        <div class="mt-4">
            <h5 class="mb-2">{{$t('modals.Set_schedule')}}</h5>

            <vs-row class="mt-4" vs-align="center" v-for="(content, index) of scheduleList" :key="index">
                <vs-col vs-w="3">
                    <div class="flex items-center">
                        <vs-icon size="small" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-days')"></vs-icon>
                        <div class="ml-2">{{ $t(`calendar.daysOfWeek.${content.day}`)}}</div>
                    </div>
                </vs-col>
                <vs-col vs-w="7">
                    <div class="flex items-center">
                        <vs-input size="small" :disabled="!content.is_active" class="inputx" type="time" v-model="content.cc_work_start"/>
                        <div class="ml-4 mr-4">:</div>
                        <vs-input size="small" :disabled="!content.is_active" class="inputx" type="time" v-model="content.cc_work_end"/>
                    </div>
                </vs-col>
                <vs-col vs-w="2">
                    <div class="flex justify-end">
                        <vs-switch  color="success" v-model="content.is_active" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check" />
                    </div>
                </vs-col>
            </vs-row>
        </div>

        <div class="mt-4 text-right">
            <vs-button :disabled="loading || !activeIntegrationsList.length" @click="send" color="primary" type="filled">{{ $t('buttons.Submit') }}</vs-button>
        </div>
    </div>
</template>

<script>
import ErrorHandler from '@/utils/errorHandler'
import EventBus from '@/store/eventBus'
import send from '@/utils/fetch'

export default {
    props: ['popupData', 'popupType', 'popupButton'],

    data() {
        return {
            loading: false,
            active: true,
            activeIntegrationsList: [],
            integrationsList: [],
            scheduleList: [
                { cc_work_end: "20:00", cc_work_start: "09:00", day: "Monday", is_active: true, leads: 0, remainder: 0, set: 0 },
                { cc_work_end: "20:00", cc_work_start: "09:00", day: "Tuesday", is_active: true, leads: 0, remainder: 0, set: 0 },
                { cc_work_end: "20:00", cc_work_start: "09:00", day: "Wednesday", is_active: true, leads: 0, remainder: 0, set: 0 },
                { cc_work_end: "20:00", cc_work_start: "09:00", day: "Thursday", is_active: true, leads: 0, remainder: 0, set: 0 },
                { cc_work_end: "20:00", cc_work_start: "09:00", day: "Friday", is_active: true, leads: 0, remainder: 0, set: 0 },
                { cc_work_end: "20:00", cc_work_start: "09:00", day: "Saturday", is_active: false, leads: 0, remainder: 0, set: 0 },
                { cc_work_end: "20:00", cc_work_start: "09:00", day: "Sunday", is_active: false, leads: 0, remainder: 0, set: 0 }
            ]
        }
    },

    computed: {
        integrations() {
            return this.integrationsList
        }
    },

    watch: {
        active() {
            this.setIntegration()
        }
    },

    methods: {
        setIntegration() {
            this.integrationsList = this.popupData.advertiser_integrations.map(item => ({...item, active: this.active}))
            if (this.active) {
                this.activeIntegrationsList = this.popupData.advertiser_integrations.map(item => item.id)
            } else {
                this.activeIntegrationsList = []
            }
        },

        select(data) {
            const id = this.activeIntegrationsList.find(item => item === data.id)
            if (id) {
                this.activeIntegrationsList.splice(this.activeIntegrationsList.indexOf(id), 1)
            } else {
                this.activeIntegrationsList.push(data.id)
            }

            if (!this.activeIntegrationsList.length) {
                this.active = false
            }
        },

        async send() {
            try {
                this.loading = true
                const data = {
                    id: this.popupData.id,
                    integration_ids: this.activeIntegrationsList,
                    scheduling_caps: this.scheduleList
                }

                await send(this.$url.advrtsr.update_all_int, 'POST', {data})

                EventBus.$emit('getAdv')
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.loading = false
            }
        }
    },

    mounted() {
        this.setIntegration()

        this.$store.commit('UPDATE_LOADER_STATE', false)
    }
}
</script>

<style lang="scss">
.globInt {
    .vs-con-tbody {
        border: none !important;
    }
}
</style>
